<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M6 5.4a3.4 3.4 0 0 1 2.2-3.2 4 4 0 0 1 3.8 1A3.4 3.4 0 0 1 18 5q.3 1.5-.6 2.5h1a3 3 0 0 1 2.4 1.7l.2 1v1.3a1 1 0 0 1-.8.8h-7a.3.3 0 0 1-.4-.2V8.3l-.8-.7-.8.7V12l-.3.3H3.8a1 1 0 0 1-.8-.8v-1.3a3 3 0 0 1 1.6-2.5l1-.2h1q-.7-1-.7-2m5.2 0a2 2 0 0 0-1.8-1.8 2 2 0 0 0-1.9 1.8 2 2 0 0 0 1.9 1.9 2 2 0 0 0 1.8-1.9m1.6 0a2 2 0 0 0 1.1 1.7 2 2 0 0 0 2.5-1 2 2 0 0 0-.4-2 1.9 1.9 0 0 0-3.2 1.3"
      clip-rule="evenodd"
    />
    <path
      d="m11.2 14-.3-.3H5.3a1 1 0 0 0-.9.7q-.3 2.1 0 4.1l.2 1.4a2 2 0 0 0 1.9 1.7l1.1.2 3.5.1.1-.2zm2 8a.3.3 0 0 1-.4-.3V14l.3-.3h5.6q.8 0 .9.7a12 12 0 0 1 0 4.1l-.2 1.4a2 2 0 0 1-1.9 1.7l-1.1.2z"
    />
  </svg>
</template>
